import React from 'react';
import SamuraiGame from '../SamuraiGame';

const ThreeYardReload = () => {
    return <SamuraiGame initialDrillIndex={5} />;
};

export default ThreeYardReload;
